module.exports = __webpack_public_path__ + "static/media/problem_gray.fc1021f9.svg";